<template>
  <el-input
    ref="input"
    v-model="inputValue"
    :placeholder="$attrs.placeholder || '请输入'"
    :clearable="$attrs.clearable !== false"
    v-bind="$attrs"
    @blur="handleBlur"
    v-on="$listeners"
  >
    <template v-for="name in slots" #[name]="scope">
      <slot :name="name" v-bind="scope" />
    </template>
    <span v-for="slot in slots" :key="slot" :slot="slot" />
  </el-input>
</template>
<script>
import {
  toStringPositiveInt,
  toStringInt,
  toStringNum,
  toStringNonNegativeInt,
  toStringPositiveFloat,
  toStringNonEmoji,
} from "@/utils/tools/index.js";

const rangePatternList = [
  "number",
  "int",
  "positiveInt",
  "digit",
  "money",
  "discount",
];
export default {
  name: "YsInput",
  model: {
    prop: "value",
    event: "input",
  },
  props: {
    value: {
      type: [String, Number],
      default: "",
    },
    /**
     * 输入框模式
     * number: 全体实数
     * int: 整数
     * positiveInt: 正整数
     * digit: 非负正整数
     * money: 正浮点数，最多保留两位小数
     * discount: 正浮点数，最多保留一位小数
     * none：默认不限制
     */
    pattern: {
      validator(value) {
        return [
          "number",
          "int",
          "positiveInt",
          "digit",
          "money",
          "discount",
          "nonEmoji",
          "none",
        ].includes(value);
      },
      default: "none",
    },
    validator: {
      type: Function,
    },
    /**
     * 最大值，仅在pattern属于 number｜int｜positiveInt｜digit｜money｜discount 时生效
     */
    max: {
      type: [Number, String],
    },
    /**
     * 最小值，仅在pattern属于 number｜int｜positiveInt｜digit｜money｜discount 时生效
     */
    min: {
      type: [Number, String],
    },
  },
  data() {
    return {
      inputValue: "",
    };
  },
  computed: {
    slots() {
      return Object.keys(this.$slots);
    },
  },
  watch: {
    value: {
      handler(val) {
        this.inputValue = val;
      },
      immediate: true,
    },
    inputValue: {
      handler(val) {
        const res = this.handlePatternJudge(this.pattern, val);
        this.$nextTick(() => {
          this.$emit("input", res);
        });
      },
      immediate: true,
      deep: true,
    },
    max: {
      handler(val) {
        const isInvalid =
          typeof val !== "undefined" &&
          !rangePatternList.includes(this.pattern);
        if (isInvalid) {
          console.warn(
            `YsInput组件属性 max 无效，当前 pattern 为 ${
              this.pattern
            }，须为 ${rangePatternList.join(", ")} 其中之一方可生效`
          );
        }
      },
      immediate: true,
    },
    min: {
      handler(val) {
        const isInvalid =
          typeof val !== "undefined" &&
          !rangePatternList.includes(this.pattern);
        if (isInvalid) {
          console.warn(
            `YsInput组件属性 min 无效，当前 pattern 为 ${
              this.pattern
            }，须为 ${rangePatternList.join(", ")} 其中之一方可生效`
          );
        }
      },
      immediate: true,
    },
  },
  methods: {
    // 模式判断
    handlePatternJudge(pattern, value) {
      const patternMap = {
        none: () => value,
        number: () => toStringNum(value),
        int: () => toStringInt(value),
        positiveInt: () => toStringPositiveInt(value),
        digit: () => toStringNonNegativeInt(value),
        money: () => toStringPositiveFloat(value, 2),
        discount: () => toStringPositiveFloat(value, 1),
        nonEmoji: () => toStringNonEmoji(value),
      };
      return patternMap[pattern] && patternMap[pattern]();
    },
    // 范围判断
    handleBlur() {
      const { value, pattern, max, min } = this;
      const isRangeEffective = rangePatternList.includes(pattern);
      if (
        isRangeEffective &&
        (typeof max !== "undefined" || typeof min !== "undefined") &&
        value !== ""
      ) {
        if (typeof max !== "undefined" && Number(max) - Number(value) < 0) {
          this.inputValue = `${max}`;
        } else if (
          typeof min !== "undefined" &&
          Number(value) - Number(min) < 0
        ) {
          this.inputValue = `${min}`;
        } else {
          this.inputValue = value;
        }
      }
    },
    /**
     * public focus
     */
    focus() {
      this.$refs.input.focus();
    },
    /**
     * public focus
     */
    blur() {
      this.$refs.input.blur();
    },
    select() {
      this.$refs.input.select();
    },
  },
};
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/components/YsForm/YsInput.vue